export const THIRD_PARTY_KEY_PREFIXES = ['hubspot_', 'salesforce_'];

export const PRIMARY_SALESFORCE_KEYS = [
  'salesforce_account',
  'salesforce_lead',
];

export const PRIMARY_HUBSPOT_KEYS = ['hubspot_company', 'hubspot_contact'];
export const DEPENDENT_HUBSPOT_KEYS = ['hubspot_deal', 'hubspot_contact'];

export const DEPENDENT_SALESFORCE_KEYS = [
  'salesforce_opportunity',
  'salesforce_contact',
];

export const SALESFORCE_SUB_CATEGORIES = {
  Company: ['account', 'opportunity'],
  Person: ['account', 'contact', 'lead'],
};

export const HUBSPOT_SUB_CATEGORIES = {
  Company: ['company', 'deal'],
  Person: ['company', 'contact'],
};

export const NESTABLE_NODE_KEYS = ['hubspot_contact'];

export const EMPTY_STATE_SEARCH = {
  and: [{ and: [{ match: { attribute: '', value: '' } }] }],
  version: 2,
};

export const DEFAULT_QUERY_PART = { match: { attribute: '' } };

export const DEFAULT_GROUP = { and: [DEFAULT_QUERY_PART] };

export const DEFAULT_EVENT_PART = {
  event: {
    path: '',
    count: 1,
    timeframe: 86400,
    type: 'page',
    match: 'all',
  },
};

export const emptyNode = {
  match: {
    attribute: undefined,
    value: undefined,
  },
};
